<app-header *ngIf="!load"></app-header>

<router-outlet></router-outlet>
<p *ngIf="errorMensaje" class="alert red">{{errorMensaje}}</p>
<!-- <button *ngIf="!load" class="btn btn-reload" (click)="initData() ">Actualizar</button> -->